export default __webpack_public_path__ + "static/media/ai72-2.e1341066.jpg";